import { render, staticRenderFns } from "./BriqMultilanguageColumns.vue?vue&type=template&id=406fa1e0&scoped=true&lang=pug&"
import script from "./BriqMultilanguageColumns.vue?vue&type=script&lang=js&"
export * from "./BriqMultilanguageColumns.vue?vue&type=script&lang=js&"
import style0 from "./BriqMultilanguageColumns.vue?vue&type=style&index=0&id=406fa1e0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fa1e0",
  null
  
)

export default component.exports